import utils from '@/utils';
import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import client from '@/api/client';
import { BASE_URL } from '@/constants';

export default {
	getPopupCarSales: ({ searchParams, currentPage, pageUnit }) => {
		let queryStr = '';
		if (searchParams.pmcId !== undefined) {
			queryStr = objectToQuerystring({
				pmcId: searchParams.pmcId,
				cmpnNo: searchParams.cmpnNo,
				roApcnch: searchParams.roApcnch,
				currentPage,
				pageUnit
			});
		}

		return client
			.get(`${BASE_URL}/mqy/qlty/carSale/v1/popUp/carSales` + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	chkPmcIdCampNo: param => {
		return client
			.get(`${BASE_URL}/mqy/ceqi/roApcn/v1/chkPmcIdCampNo/pmcId/${param}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	}
};
